export const stringToFloat = (value: string): number => {
  return parseFloat(value.replace(",", "."));
};

export const isStringNumber = (value: any): boolean => {
  return !isNaN(value.replace(",", "."));
};

export const numberToCommaStringFormat = (
  value: number | null | undefined,
  fixedDecimals: number
): string => {
  if (!value) {
    const zero = 0;
    return zero.toFixed(fixedDecimals).replace(".", ",");
  }
  return value.toFixed(fixedDecimals).replace(".", ",");
};

export const minutesFromHoursMinutesDecimal = (hoursMinutesDecimals: number): number => {
  const minutesWithDecimals = (hoursMinutesDecimals % 1) * 60;
  const minutes = Math.round((minutesWithDecimals + Number.EPSILON) * 100) / 100;
  return Math.round(minutes);
};

export const weekAverageInHoursMinutesFormat = (averagePerDayInDecimals: number): string => {
  const minutes = minutesFromHoursMinutesDecimal(averagePerDayInDecimals);
  const hours = Math.floor(averagePerDayInDecimals);
  const minTimesFive = minutes * 5;
  const hoursX = Math.floor(minTimesFive / 60);
  const hoursPerWeek = hours * 5 + hoursX;
  const minutesPerWeek = minTimesFive - hoursX * 60;
  //'0' + slice(-2) padder tal med 0 hvis de er mellem 0-9.
  return (
    ("0" + hoursPerWeek).slice(-2) +
    ":" +
    ("0" + (minutesPerWeek === 60 ? 0 : minutesPerWeek)).slice(-2)
  );
};
